// Keys copied from reffie/models/property_fact.py :: PropertyFactKey
export const PROPERTY_FACT_KEYS = [
    'policy_document_link',
    'pet_policy',
    'listing_link',
    'website',
    'min_income_multiple',
    'is_furnished',
    'income_requirements',
    'tour_times',
    'is_affordable_housing',
    'onsite_team',
] as const;

export type PropertyFactKey = typeof PROPERTY_FACT_KEYS[number];

export const PROPERTY_FACT_KEY_LABELS: Record<PropertyFactKey, string> = {
    policy_document_link: 'Policy document link',
    pet_policy: 'Pet policy',
    listing_link: 'Listing link',
    website: 'Website',
    min_income_multiple: 'Min income multiple',
    is_furnished: 'Furnished',
    income_requirements: 'Income requirements',
    tour_times: 'Tour times',
    is_affordable_housing: 'Affordable housing',
    onsite_team: 'Onsite team',
};
